import { Boxes } from "lucide-react";
import { cn } from "@/lib/utils";

/** Display-only helper: is this load an LTL / partial shipment? */
export function isLtlLoad(loadType: string | null | undefined): boolean {
  const v = (loadType ?? "").trim().toLowerCase();
  return v === "ltl" || v === "partial";
}

interface LtlBadgeProps {
  className?: string;
  /** "compact" = tiny board chip, "default" = row/card chip, "lg" = detail header */
  size?: "compact" | "default" | "lg";
  label?: string;
}

/** High-visibility amber LTL badge. Purely presentational. */
export function LtlBadge({ className, size = "default", label }: LtlBadgeProps) {
  const sizes = {
    compact: "h-4 px-1 text-[9px] gap-0.5",
    default: "h-5 px-1.5 text-[10px] gap-1",
    lg: "h-6 px-2 text-[11px] gap-1",
  }[size];

  return (
    <span
      title="LTL / Partial shipment — not a full truckload"
      className={cn(
        "inline-flex shrink-0 items-center rounded-sm border border-amber-500 bg-amber-100 font-bold uppercase tracking-wide text-amber-900",
        sizes,
        className,
      )}
    >
      <Boxes className={size === "compact" ? "h-2.5 w-2.5" : "h-3 w-3"} />
      {label ?? "LTL"}
    </span>
  );
}
